export default "__VITE_ASSET__ruaBBmIp__"